module.exports = __webpack_public_path__ + "static/media/img-023.32616fd3.jpg";